import React from 'react';

import ActionCard from '../../components/ActionCard';
import Button from '../../components/Button';

function TemplateLibraryCard({template}) {
  return (
    <ActionCard
      title={template.name}
      description={template.description}
      action={<Button to={`/forms/create/library/${template.id}`}>Use Template</Button>}
    />
  );
}

export default TemplateLibraryCard;
